const traducoes = {
  traducoes: {
    slugs: {
      menu: 'menú',
      sobreAFeira: 'sobre-una-feria',
      sicc: 'sicc',
      gramado: 'gramado',
      novoHamburgo: 'novo-hamburgo',
      fenac: 'fenac',
      serraPark: 'serra-park',
      parceiros: 'socios',
      grupoDeImportadores: 'grupo-importador',
      estacao3: 'estacion-3',
      conectech: 'conectech',
      queroVisitar: 'quiero-visitar',
      hospedagem: 'hospedaje',
      traslado: 'transferir',
      credenciamento: 'acreditación',
      agenciaDeTurismo: 'agencia-de-turismo',
      expositores: 'expositores',
      expositoresCategoriaFeminino: 'calcados-femininos',
      expositoresCategoriaMasculino: 'calcados-masculinos',
      expositoresCategoriaInfantil: 'calcados-infantis',
      expositoresCategoriaBolsasAcessorios:
        'bolsas-acessorios-e-artefatos-de-couro',
      expositoresCategoriaEsportivos: 'calcados-esportivos',
      plantaBaixa: 'planta-baja',
      eMerkator: 'e-merkator',
      eMerkatorTalks: 'e-merkator-charlas',
      eMerkatorBlog: 'e-merkator-blog',
      eMerkatorTV: 'e-merkator-tv',
      eMerkatorCast: 'e-merkator-cast',
      eMerkatorPush: 'e-merkator-push',
      imprensa: 'prensa',
      noticias: 'noticias',
      galeriaDeImagens: 'galería-de-imágenes',
      contato: 'contacto',
      programacoes: 'horarios',
      protocolo: 'protocolo',
    },
    cabecalho: {
      painelExpositor: 'Panel de expositores',
      menu: 'Menú',
      sobreAFeira: 'Sobre la Feria',
      sicc: 'SICC',
      gramado: 'Gramado',
      novoHamburgo: 'Novo Hamburgo',
      fenac: 'Fenac',
      serraPark: 'Serra Park',
      parceiros: 'Socios',
      grupoDeImportadores: 'Grupo de importadores',
      estacao3: 'Estación 3',
      conectech: 'Conectech',
      queroVisitar: 'Quiero Visitar',
      hospedagem: 'Alojamiento',
      traslado: 'Transferir',
      credenciamento: 'Acreditación',
      agenciaDeTurismo: 'Agencia de Turismo',
      expositores: 'Expositores',
      plantaBaixa: 'Planta baja',
      eMerkator: 'eMerkator',
      eMerkatorTalks: 'Charlas de eMerkator',
      eMerkatorBlog: 'Blog de eMerkator',
      eMerkatorTV: 'eMerkator TV',
      eMerkatorCast: 'eMerkator Cast',
      eMerkatorPush: 'eMerkator Push',
      imprensa: 'Prensa',
      noticias: 'Noticias',
      galeriaDeImagens: 'galería de imágenes',
      contato: 'Contacto',
    },
    paginas: {
      inicial: {
        secaoSicc: {
          titulo: 'SICC - Salón Internacional del Cuero y Calzado',
          subTitulo: 'La nueva cara de la moda',
          botaoQueroVisitar: 'Quiero Visitar',
          botaoProtocolo: 'Protocolo de medidas de prevenção ao Covid-19',
          botaoGaleria: 'Galería',
          conteudo: '',
        },
        secaoGramado: {
          titulo: 'Césped',
          conteudo: '',
        },
        secaoSerraPark: {
          titulo: 'Parque de la Serra',
          subTitulo: 'Viação Férrea, nº 100, Gramado / RS',
          conteudo: '',
          tituloCaracteristicas: 'Características',
          caracteristicas: '',
        },
        secaoParceiros: {
          titulo: 'Socios',
          conteudo: '',
        },
        secaoGrupoDeImportadores: {
          titulo: 'Grupo de importadores',
          conteudo: '',
        },
        secaoEstacao3: {
          titulo: 'Estación 3',
          conteudo: '',
        },
        secaoConectech: {
          titulo: 'Conectech',
          conteudo: '',
        },
        secaoQueroVisitar: {
          titulo: 'Quiero Visitar',
          hospedagem: {
            titulo: 'ALOJAMIENTO',
            conteudo:
              '<p>Merkator Feiras e Eventos, promotora de Zero Grau, brindará alojamiento de cortesía en hoteles de Serra Gaúcha, durante el período de la feria. Las cortesías son exclusivas para los minoristas del sector del calzado.</p>',
            textoBotao: 'Solicitudes cerradas',
            textoEmBreve: 'Disponible Pronto',
            subTextoBotao: '',
          },
          translado: {
            titulo: 'TRANSFERIR',
            conteudo:
              '<p> Consulte a continuación las opciones de transporte para llegar al evento:<br />Tren: Bájese en la estación FENAC. La estación se encuentra justo enfrente del recinto del evento, lo que ofrece un acceso rápido y cómodo.<br />Autos de alquiler (Uber/99): En la zona se ofrecen servicios de transporte a través de aplicaciones de transporte, una alternativa práctica.<br />Autos de alquiler: Varias compañías de alquiler de autos operan en la zona para quienes prefieren mayor autonomía.<br />Vehículos propios: FENAC dispone de aparcamiento propio (de pago).</p>',
            textoBotao: 'Tiempos y valores aquí',
            textoEmBreve: 'Disponible Pronto',
            subTextoBotao: '',
          },
          credenciamento: {
            titulo: 'Acreditación',
            conteudo:
              '<p> Merkator quiere facilitar su entrada a la feria. Con este procedimiento tienes una insignia listo esperándote en la ventana de Acreditación Temprana y poder Ingrese a la feria para conocer los principales lanzamientos primavera-verano en la industria de la cal y accesorios en Brasil. </p>',
            textoBotao: 'Registrarse aquí',
            textoEmBreve: 'Disponible Pronto',
            subTextoBotao: 'Acreditación disponible próximamente',
          },
        },
        secaoAgenciaDeTurismo: {
          titulo: 'Agencia de turismo',
          conteudo:
            '<p> Sunpower Turismo, & eacute; agencia de viajes oficial de la feria. </p> <p> Cuenta con un equipo de profesionales calificados y con experiencia, brindando siempre un servicio personalizado de calidad, con un enfoque en la satisfacción del cliente. </p> <p> Ofrecemos todos los servicios de logística de viajes con descuentos especiales para los participantes / expositores de la feria. </p> <p> - Alojamiento; <br /> - Pasaje a & eacute; área; <br /> - Alquiler de coches. </p> <p> ¡Te recordamos que las reservas solicitadas con anticipación garantizan las mejores tarifas y condiciones! </p> <p> Más información & ccedil; & otilde; es, siga nuestros contactos: <br /> Sunpower Turismo <br /> +55 54-3286 5033 <br /> reservas@sunpowerturismo.com.br | www.sunpowerturismo.com.br </p>',
          subTitulo: 'Agencia Oficial de Turismo',
        },
        secaoExpositores: {
          titulo: 'Expositores',
          subTitulo: 'Seleccione el producto deseado:',
          subTituloBreve: 'Disponible Pronto',
        },
        secaoPlantaDaFeira: {
          titulo: 'Planta baja',
          description: 'Haga click aquí para descargar',
        },
        secaoEMerkator: {
          titulo: 'eMerkator',
          subTitulo: 'Te conecta con el mercado',
          textoLinkProgramacao: 'Agenda completa',
        },
        secaoImprensa: {
          titulo: 'Prensa',
          noticias: 'Noticias',
          galeriaDeImagens: 'Galería de imágenes',
          falarComImprensa: 'Quiero hablar con la oficina de prensa',
        },
      },
      noticias: {
        secaoNoticias: {
          titulo: 'Noticias',
        },
      },
      noticia: {
        secaoNoticia: {
          titulo: 'Noticias',
          tituloNoticia: '',
          legendaImagem: '',
          textoTags: 'TAGS',
          conteudo: '',
        },
      },
      galerias: {
        titulo: 'Galerías',
      },
      programacoes: {
        secaoProgramacoes: {
          titulo: 'Horarios',
          diasSemana: {
            0: 'Domingo',
            1: 'Lunes',
            2: 'Martes',
            3: 'Miércoles',
            4: 'Jueves',
            5: 'Viernes',
            6: 'Sabado',
          },
          noRegister: 'Próximamente agenda completa',
        },
      },
      programacao: {
        secaoProgramacao: {
          titulo: 'Calendario',
        },
      },
      traslado: {
        titulo: 'Transferir',
        description:
          '<p>La transferencia desde el Aeropuerto Internacional Salgado Filho, en Porto Alegre-Rio Grande do Sul, a los hoteles seleccionados será realizado por el equipo de transporte oficial subcontratado por Zero Grau como manera de proporcionar a los visitantes una mayor comodidad y seguridad.</p><p class="font-bold-blue">Para utilizar el transporte oficial de Zero Grau es obligatorio presentar la credencial de la feria. El uso del servicio es exclusivo para los participantes de la feria.</p><p>El equipo de Merkator, Zero Grau – Feria de Calzado y Accesorios , estará en la terminal de llegadas coordinando las transferencias de hotel mencionadas anteriormente.</p><p>Servicio al Cliente:<br><b>+55 54 99163-1410 (Whatsapp)<br />+55 54 3282-5445 (Teléfono - Servicio General)<br /> eventos@brockerturismo.com.br</b></p>',
        textTrasnporteOficial: 'Transporte Oficial',
        textBotaoComprar: 'Entradas aquí',
        textBotaoValores: 'Valores',
        textEventoDiaUm: 'Domingo 19.11',
        textEventoDiaDois: 'Lunes 20.11',
        textEventoDiaTres: 'Marte 21.11',
        textEventoDiaQuatro: 'Miércoles 22.11',
        textEventoDiaCinco: 'Jueves 23.11',
        textTitleDescriptionDiaUm:
          '<p>Salida desde el Aeropuerto de Porto Alegre hacia los hoteles socios de la Feria.</p>',
        textDescriptionDiaUm:
          '<p><b>10h | 12h | 14h | 16h | 18h | 20h | 22h * </b></p><p><b>NOTA: Si estos horarios no se ajustan a sus necesidades, comuníquese directamente con el equipo de Brocker Turismo, nuestro socio oficial.</b><br />*Los horarios expuestos anteriormente pueden cambiar en función de la necesidad y demanda.</p>',
        textTitleDescriptionDiaDois:
          '<p>Salida desde el Aeropuerto de Porto Alegre hacia la feria.</p>',
        textDescriptionDiaDois:
          '<p><b>8h | 10h | 12h | 14h | 16h | 18h | 20h | 22h | 00h</b></p>',
        textTitleDescriptionDiaTres:
          '<p>Salida desde el Aeropuerto de Porto Alegre hacia la feria.</p>',
        textTitleDescriptionDiaTresV:
          '<p>Salida de la feria al Aeropuerto de Porto Alegre</p>',
        textDescriptionDiaTres: '<p><b>9h</b></p>',
        textDescriptionDiaTresV:
          '<p><b>14h30min (Hora prevista)</b></p><p>Es responsabilidad exclusiva del comerciante programar su devolución, en el mostrador de transferencia en el registro 2 de la feria.</p>',
        textTitleDescriptionDiaQuatro:
          '<p>Solo Regreso de Gramado (de la Feria), los horarios deben ser agendados en el mostrador de Transfer de la feria.',
        textTitleDescriptionDiaQuatroV:
          '<p>Salida de la feria al Aeropuerto de Porto Alegre</p>',
        textDescriptionDiaQuatro: '<p></p>',
        textDescriptionDiaQuatroV:
          '<p><b>10h | 12h | 14h | 16h | 18h | 20h | 22h * </b></p><p><b>NOTA: Si estos horarios no se ajustan a sus necesidades, comuníquese directamente con el equipo de Brocker Turismo, nuestro socio oficial.</b><br />*Los horarios expuestos anteriormente pueden cambiar en función de la necesidad y demanda.</p>',
        textTitleDescriptionDiaCinco:
          '<p>Salida de Gramado al Aeropuerto de Porto AlegreGramado/Canela al aeropuerto Salgado Filho <br/>(recogida en el hotel)</p>',
        textDescriptionDiaCinco:
          '<p><b>4h | 6h | 8 h | 10h | 12h | 14h</b></p>',
        titleTicketUnico: 'BILLETE <br/>SENCILLO',
        titleDescriptionUnico:
          '<p>Aeropuerto (POA) > Gramado/Canela o Gramado/Canela > Aeropuerto (POA)</p>',
        precoTicketUnico: 'R$ 100,00',
        comboTicketUnico: 'COMBO DE <br/>IDA Y VUELTA',
        comboDescriptionUnico:
          '<p>Aeropuerto (POA) > Gramado/Canela y Gramado/Canela > Aeropuerto (POA)</p>',
        precoComboTicketUnico: 'R$ 230,00',
        observacaoIdaVolta:
          'En caso de cancelación del paquete de ida y vuelta, se descontará el valor de R$ 100,00 por segmento.',
        titleTicketAvulso: 'BILLETE <br/> INTERNO',
        descriptionTicketAvulso:
          '<p>Hotel Acreditado / Serra Park – Serra Park / Hotel Acreditado (Tres días)</p>',
        precoTicketAvulso: '<p>R$ 90,00</p>',
        observacaoTicketAvulso:
          'Comprando, el traslado ida y vuelta del Aeropuerto a Gramado/Canela, el traslado interno es gratuito.',
        titleComboFeira: 'COMBO <br/> JUSTO',
        descriptionComboFeira:
          '<p>Hotel para feria y<br /> Feria para hotel <br /> (todos los días del evento)</p>',
        precoComboFeira: '<p>R$ 20,00</p>',
        porPessoa: '',
        textCompreAqui: 'ENTRADAS AQUÍ',
        descriptionValor: '<p></p>',
        observationBoxValue: '',
      },
      expositores: {
        titulo: 'Expositores',
        botaoCategoria: {
          listaCompleta: 'Lista llena',
          feminino: 'Calzado para Mujer',
          masculino: 'Calzado para Hombres',
          infantil: 'Calzado para Niños',
          acessorios: 'Bolsa Y Accessorios',
          esportivos: 'Calzado Desportivo',
        },
      },
      eMerkatorTv: {
        titulo: 'eMerkator TV',
      },
      pagina404: {
        titulo: 'Página no encontrada.',
      },
    },
    componentes: {
      painelExpositor: {
        email: 'Correo electrónico',
        senha: 'Contraseña',
        entrar: 'Enter',
        cancelar: 'Cancelar',
        esqueciMinhaSenha: 'Olvidé mi contraseña',
      },
      secao: {
        botaoVoltar: 'Regresar',
      },
      cabecalho: {
        linguagem: 'Idioma',
        portugues: 'portugués',
        ingles: 'inglés',
        espanhol: 'Español',
      },
      rodape: {
        baixeNossoApp: 'Disponible sur',
        disponivelNa: 'Disponible en',
      },
      secaoEMerkator: {
        programacaoCompleta: 'Programación completa',
      },
    },
  },
};

export default traducoes;
